<template>
  <div >
    <div class="set_box">
      <div class="left_box">
        <div class="list">
          {{$t('take_profit')}}
          <el-input v-model="stop.up" type='number' :placeholder="$t('enter_content')"></el-input>%
        </div>
        <div class="list">
          {{$t('stop_loss')}}
          <el-input v-model="stop.down" type='number' :placeholder="$t('enter_content')"></el-input>%
        </div>
      </div>
      <div class="right_box" @click="setPnl">
        {{$t("submit")}}
      </div>
    </div>
  </div>
</template>

<script>
import {createLeadingContractAndCall, createLeadingContractAndSend} from "../utils/contract";
import {Method} from "../config/const";

export default {
  name: "activate5",
  props:{
    contractAddress:"",
    token:""
  },
  data(){
    return{
      stop:{
        up:10,
        down:12
      },
    }
  },
  methods: {
    async setPnl(){
      let tex=await createLeadingContractAndSend(this.contractAddress,Method.setPnL,[this.stop.up,this.stop.down])
      console.log("tx is",tx);
    },
    async getCurrentPnl(){
      let res=await createLeadingContractAndCall(this.contractAddress,Method.currentPnl);
      this.stop.up=res[0]
      this.stop.down=res[1]
    },
    init(){
      console.log("init",5);
      this.getCurrentPnl()
    }
  },
  created() {
  }
}
</script>

<style src="../assets/list.scss" lang="scss" scoped></style>
<style src="../assets/css/index.scss" lang="scss" scoped></style>
<style>
.el-table, .el-table__expanded-cell{
  background-color: rgba(24, 26, 32, 1);
}
</style>
<style src="../assets/css/mobile.scss" lang="scss" scoped></style>
